module.exports = __webpack_public_path__ + "img/social-marketing-banner-test-1.b009fb46.jpg";